import { useEffect, useState } from "react";
import ImageZoomRotate from "react-image-pan-zoom-rotate";
import { OrderImage } from "src/types";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export function ImageViewer({ images = [] }: { images: OrderImage[] | null }) {
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    const imageURLs = images?.map((img) => img.imageUrl);

    useEffect(() => {
        setCurrentIndex(0);
    }, [images]);

    if (!images) {
        return (
            <div className="h-full">
                <div className="flex justify-start space-x-2">
                    <div>
                        <button className="btn btn-xs text-xs" disabled={true}>
                            <FaChevronLeft />
                        </button>
                    </div>
                    <span className="text-base">0 / 0</span>
                    <div>
                        <button className="btn btn-xs text-xs" disabled={true}>
                            <FaChevronLeft />
                        </button>
                    </div>
                </div>

                <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                    Select document to view
                </div>
            </div>
        );
    }

    if (imageURLs![currentIndex] === null) {
        return (
            <div className="h-full">
                <div className="flex justify-start space-x-2">
                    <div>
                        <button
                            className="btn btn-xs text-xs"
                            disabled={true}
                            onClick={() =>
                                setCurrentIndex((prev) => {
                                    return prev - 1;
                                })
                            }
                        >
                            <FaChevronLeft />
                        </button>
                    </div>
                    <span className="text-white">
                        {currentIndex + 1} / {imageURLs?.length}
                    </span>
                    <div>
                        <button
                            className="btn btn-xs text-xs"
                            disabled={currentIndex + 1 >= imageURLs!.length}
                            onClick={() =>
                                setCurrentIndex((prev) => {
                                    return prev + 1;
                                })
                            }
                        >
                            <FaChevronRight />
                        </button>
                    </div>
                </div>

                <div className="bg-white rounded-sm p-3 h-full flex items-center justify-center text-gray-500">
                    No image available
                </div>
            </div>
        );
    }

    return (
        <div className="flex-1 flex flex-col overflow-y-auto">
            <div className="flex justify-start space-x-2 pb-1">
                <div>
                    <button
                        className="btn btn-xs text-xs"
                        disabled={currentIndex === null || currentIndex === 0}
                        onClick={() =>
                            setCurrentIndex((prev) => {
                                return prev - 1;
                            })
                        }
                    >
                        <FaChevronLeft />
                    </button>
                </div>
                <span className="text-white">
                    {currentIndex + 1} / {imageURLs?.length}
                </span>
                <div>
                    <button
                        className="btn btn-xs text-xs"
                        disabled={
                            currentIndex === null ||
                            imageURLs!.length === 1 ||
                            currentIndex === imageURLs!.length - 1
                        }
                        onClick={() =>
                            setCurrentIndex((prev) => {
                                return prev + 1;
                            })
                        }
                    >
                        <FaChevronRight />
                    </button>
                </div>
            </div>
            <div className="flex-1 relative overflow-hidden">
                <ImageZoomRotate
                    key={JSON.stringify(imageURLs)}
                    image={imageURLs![currentIndex] ?? ""}
                />
            </div>
        </div>
    );
}
